import { SVGProps } from "react";

const Vietnam = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#D80027"
      />
      <path
        d="M12 7L13.1803 10.4377H17L13.9098 12.5623L15.0901 16L12 13.8754L8.90981 16L10.0902 12.5623L7 10.4377H10.8196L12 7Z"
        fill="#FFDA44"
      />
    </svg>
  );
};

export default Vietnam;
